import { render, staticRenderFns } from "./mitigationTypes.vue?vue&type=template&id=8434369c"
import script from "./mitigationTypes.vue?vue&type=script&lang=js"
export * from "./mitigationTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports